const InputCSS = {
  textIndent: "50px",
  fontSize: "16px",
  fontFamily: "Work Sans",
  fontStyle: "normal",
};

export default InputCSS;
